// extracted by mini-css-extract-plugin
module.exports = {"Loading":"loading_Loading__1te60","acorn":"loading_acorn__3zMgz","bounce":"loading_bounce__1-xJ3"};